import React from "react";
import { Row, Alert } from "antd";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroller";

import ClassList from "common/class_card/ClassList";
import GET_TEACHER_CLASSES from "graphql/queries/GetTeacherClasses";
import { CenteredLoading } from "common/loading";

import useInfiniteQuery from "hooks/useInfiniteQuery";

const DEFAULT_PAGE_SIZE = 4;

interface JoinMyClassesProps {
  teacherId: number;
  levelId: string;
}

const JoinMyClasses = ({ teacherId, levelId }: JoinMyClassesProps) => {
  const { t } = useTranslation("teacher_profile");

  const filterParams =
    levelId === "0"
      ? {
          teacherId,
          first: DEFAULT_PAGE_SIZE,
        }
      : {
          teacherId,
          levelId,
          first: DEFAULT_PAGE_SIZE,
        };

  const {
    nodes: teacherClasses,
    loading,
    error,
    loadMore,
    pageInfo,
  } = useInfiniteQuery("teacherClasses", GET_TEACHER_CLASSES, {
    variables: filterParams,
  });

  if (loading) {
    return <Alert type="info" message="Loading..." />;
  }

  if (error) {
    return (
      <Alert
        type="error"
        message="Error loading teacher profile. Please check your internet or let us know if this keeps happening."
      />
    );
  }

  if (!teacherClasses) return null;

  if (teacherClasses.length === 0)
    return <Alert type="info" message={t("No class")} />;
  return (
    <InfiniteScroll
      pageStart={0}
      loadMore={loadMore}
      hasMore={pageInfo?.hasNextPage}
      loader={<CenteredLoading key={0} />}
    >
      <Row gutter={24}>
        <ClassList lessons={teacherClasses || []} allowsBooking />
      </Row>
    </InfiniteScroll>
  );
};

export default JoinMyClasses;
